export const NAV_ITEMS = [
  { name: 'Home', icon: '🏠', view: 'home' },
  { name: 'Ecoling', icon: '🐥', view: 'sprout' },
  { name: 'Calendar', icon: '📅', view: 'history' },
  { name: 'Leaders', icon: '🏆', view: 'leaderboard' },
  { name: 'Profile', icon: '👤', view: 'profile' },
];
